import { render, staticRenderFns } from "./editor-input-validation.vue?vue&type=template&id=65df423c&"
import script from "./editor-input-validation.vue?vue&type=script&lang=js&"
export * from "./editor-input-validation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports